import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Heading from '../../../components/Typography/Heading/Heading';
import styles from './ProfileDetails.module.scss';
import cn from 'classnames';
const ProfileDetails = ({ title, children, className, text, onClick }) => {
    return (_jsxs("div", Object.assign({ className: cn(styles.element, className) }, { children: [_jsxs("div", Object.assign({ className: 'd-flex justify-content-between' }, { children: [_jsx(Heading, { className: styles.heading, size: 3, fontWeight: 500, title: title }), text && (_jsx(Heading, { onClick: onClick, className: cn(styles.heading, styles.text), size: 3, fontWeight: 500, title: text }))] })), children] })));
};
export default ProfileDetails;
